import React from 'react'

import Nav from '../Nav'
import Logo from '../Logo'

class Header extends React.Component {
  render(){

    const { destination } = this.props;

    if (destination){
        return(
          <div className="wrapper-main_header">
            <Logo className="wrapper-main_logo" />
            <Nav className="wrapper-main_nav" destination />
          </div>
        )} else {
          return(
            <div className="wrapper-main_header">
              <Logo className="wrapper-main_logo" />
              <Nav className="wrapper-main_nav" />
            </div>
          )
        }
      }
    }

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/index.js